import { AppResources } from "@/constants";

/**
 * Default Wizzy images used for all onboarding steps
 * Individual steps can override these in WIZZY_IMAGES_BY_STEP
 */
export const DEFAULT_WIZZY_IMAGES = {
  default: AppResources.wizzyWand,
  hover: AppResources.wizzyMegaphone,
};

/**
 * Configuration map for step-specific Wizzy images (override defaults per step)
 * If hover is not specified, the default image will be used (no change on hover)
 */
export const WIZZY_IMAGES_BY_STEP: Record<
  string,
  { default: string; hover?: string }
> = {
  accountCreation: {
    default: AppResources.wizzyId,
  },
  contractCommitmentSetup: {
    default: AppResources.wizzyPayment,
    hover: AppResources.wizzyFind,
  },
  contractCommitmentPayment: {
    default: AppResources.wizzyPayment,
    hover: AppResources.wizzyFind,
  },
  extension: {
    default: AppResources.wizzyPuzzle,
  },
  customizeOneClick: {
    default: AppResources.wizzyToggle,
  },
  // Add more step-specific overrides here as needed
};
